import {
  SITE_SETTINGS_LOADER,
  SET_SITE_SETTINGS,
  FETCH_CALCULATOR,
  FORM_SUBMITED,
  DOWNLOAD_COUNT,
} from "../actionTypes";

const initialState = {
  loader: false,
  siteSettingsData: [],
  calculatorData: {},
  isSubmit: false,
};

const siteSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SITE_SETTINGS_LOADER:
      return {
        ...state,
        loader: action?.payload,
      };
    case FORM_SUBMITED:
      return {
        ...state,
        isSubmit: action?.payload,
      };
    case SET_SITE_SETTINGS: {
      return {
        ...state,
        siteSettingsData: action.payload,
      };
    }
    case FETCH_CALCULATOR: {
      return {
        ...state,
        calculatorData: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          calculatorData: {
            ...state.calculatorData,
            fileViewCount: (state.calculatorData?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          calculatorData: {
            ...state.calculatorData,
            downloadCount: (state.calculatorData?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default siteSettingsReducer;
